import { extractTermPaths } from 'lib/taxonomy';
import get from 'lodash.get';

const getInlineNewsletterConfig = (
  article,
  isChromeless,
  newsletterData = [],
) => {
  const {
    taxonomy = [],
  } = article;

  if (article.nativeAd || article.subType === 'liveBlog' || isChromeless) return null;

  let newsletter;
  const termPaths = extractTermPaths(taxonomy);

  const formatTaxCondition = (input) => {
    if (typeof input === 'string' && input.length > 0) {
      return input.split(/\n/);
    }
    return [];
  };

  const termCompare = (compare) => compare.filter((val) => termPaths.includes(val)).length;

  for (let c = 0; c < newsletterData.length; c += 1) {
    const incl = formatTaxCondition(get(newsletterData, [c, 'includedTaxonomyPaths'], ''));
    const excl = formatTaxCondition(get(newsletterData, [c, 'excludedTaxonomyPaths'], ''));

    // Has NO excluded taxonomy
    if (excl.length && termCompare(excl) >= 1) {
      break;
    }
    // Has ALL included taxonomy
    if (incl.length && incl.length === termCompare(incl)) {
      // TODO: (BENTO-15008) Implement specificity logic in the case of multiple config matches
      newsletter = newsletterData[c];
      break;
    }
  }
  return newsletter;
};

export { getInlineNewsletterConfig };
